import BlockedGetAccess from './BlockedGetAccess';

export default BlockedGetAccess;
